"use client";

import { rpc } from "#rpc";
import { useQuery } from "@tanstack/react-query";
import dynamic from "next/dynamic";
import { Suspense } from "react";

const FooterWeatherUI = dynamic(
  () => import("./FooterWeatherUI").then(mod => mod.FooterWeatherUI),
  { ssr: false },
);

const UnsuspendedFooterWeather = () => {
  const { data: windspeed } = useQuery({
    queryKey: ["weather-data"],
    queryFn: () => rpc.bloks.fetchWeatherLocations(),
  });

  if (!windspeed) return null;

  return <FooterWeatherUI windspeed={windspeed} />;
};

export const FooterWeather: typeof UnsuspendedFooterWeather = () => {
  return (
    <Suspense>
      <UnsuspendedFooterWeather />
    </Suspense>
  );
};
